<template>
  <b-modal
    id="add-pto"
    ref="add-pto"
    size="sm-size"
    modal-class="break-modal"
    centered
    hide-footer
    hide-header
    @hide="onModalHide"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{ label.get('add_time_off_code') }}
      </h2>
    </div>



    <div class="content-wrapper hasScroll">
      <perfect-scrollbar>
        <div class="form-container">
          <div
              v-for="(item, idx) in ptos"
              :key="idx"
              class="input-wrapper"
          >
            <div class="name-holder">
              <span class="heading-title">{{ label.get('name') }}</span>
              <input
                  v-model="item.name"
                  ref="job"
                  type="text"
                  :placeholder="label.get('time_off_code_name')"
                  class="atto-input"
              >
            </div>
            <div class="type-holder">
              <span class="heading-title">{{ label.get('type') }}</span>
              <select-dropdown-component
                  :value="item.type"
                  placeholder="Select method"
                  :options="ptoTypes"
                  :index="idx"
                  @onOptionSelected="onPaidRulesChanged"
              />
            </div>

          </div>
          <button
              class="add-new-btn"
              @click="addMorePto"
          >
            <i class="atto atto-add-more" />
            {{label.get('add_another_time_off_code')}}
          </button>
        </div>
      </perfect-scrollbar>
    </div>
    <div class="modal-footer">
      <div class="form-buttons">
        <button
          class="atto-btn cancel"
          :disabled="disabledSaveButton"
          @click="discardNewPto"
        >
          {{ label.get('cancel') }}
        </button>
        <button
          class="atto-btn submit"
          @click="addNewPto"
        >
          {{ label.get('add_code') }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
    import PtoService from '../services/PtoService';
    import SelectDropdownComponent from "../../../../shared/components/SelectDropdownComponent";
    import BreakPreferencesService from "../../break-preferences/services/BreakPreferencesService";
    export default {
        name: "AddPtoComponent",
        components: {
          SelectDropdownComponent
        },
        data() {
            return {
                disabledSaveButton: false,
                ptoTypes: this.getTimeOffTypes(),
                ptos: [
                    {
                        id: null,
                        name: '',
                        type: 1
                    }
                ]
            }
        },
        mounted() {
            document.body.appendChild(this.$el);
            this.$refs['add-pto'].show();
        },
        methods: {
            getTimeOffTypes(){
              return PtoService.getPtoTypes(this.label);
            },
            onPaidRulesChanged(option, idx){
              this.ptos[idx].type = option.value;
            },
            onModalHide() {
                this.$root.$emit('hideAddPto');
            },
            discardNewPto() {
                this.$refs['add-pto'].hide();
            },
            addMorePto() {
                let emptyFields = false;
                this.ptos.forEach((item) => {
                    if (item.name.trim() === '') {
                        emptyFields = true;
                    }
                });

                if (!emptyFields) {
                    this.ptos.push({
                        id: null,
                        name: '',
                        type : 1
                    });
                }
            },
            addNewPto() {
                const data = this.ptos.filter((item) => {
                    return item.name.trim() !== '';
                });

                if(data.length === 0) { return; }

                this.disabledSaveButton = true;
                PtoService.newPto({ptos: data}).then((result) => {
                    this.$root.$emit('hideAddPto', result.data);
                }).catch((error) => {
                    this.disabledSaveButton = false;
                });
            }
        }
    }
</script>


